// extracted by mini-css-extract-plugin
module.exports = {"red":"submenuProject_red__tSKCa","green":"submenuProject_green__3YY4X"};